import type { ServiceRun } from '../../api/monitor';
import { RUN_TONE, formatDuration } from '../../lib/serviceRuns';

/** Data completa: no histórico "há 3 h" não serve para cruzar com log. */
function formatStartedAt(startedAt: string): string {
  return new Date(startedAt).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

/**
 * Uma execução no histórico. O motivo da falha fica na própria linha, e não
 * atrás de um clique: a tela existe justamente para responder "o que quebrou".
 */
export function RunRow({ run }: { run: ServiceRun }) {
  const tone = RUN_TONE[run.status];

  return (
    <div className="border-line-200 border-b p-3.5 last:border-b-0">
      <div className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-[13px] font-bold" title={run.label}>
          {run.label}
        </span>
        <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10.5px] font-bold ${tone.pill}`}>
          {tone.label}
        </span>
      </div>

      <div className="text-ink-400 mt-1 text-[11.5px]">
        {formatStartedAt(run.startedAt)} · {run.service} ·{' '}
        {run.triggeredBy === 'manual' ? 'disparo manual' : 'agendado'} ·{' '}
        {run.processed} {run.processed === 1 ? 'item' : 'itens'}
        {run.failed > 0 ? ` · ${run.failed} ${run.failed === 1 ? 'falha' : 'falhas'}` : ''}
        {run.status === 'running' ? '' : ` · ${formatDuration(run.durationMs)}`}
      </div>

      {run.error ? (
        <div className="text-danger-600 mt-1 text-[11.5px] font-semibold break-words">
          {run.error}
        </div>
      ) : null}
    </div>
  );
}
